<template>
  <div class="card-status-overlay">
    <div v-if="status === 'lock' || status === 'unlock'">
      <p>Locking a card prevents it from being used for new purchases. Unlock the card to resume usage.</p>
      <div class="form-group">
        <p><strong>Lock Card Activity</strong></p>
        <ed-switch slot="body" id="lock-switch" v-model="isActive"></ed-switch>
        <p v-if="cardStatusMessage" class="card-status-message">{{ cardStatusMessage }}</p>
      </div>
      <div v-if="isEvedAdmin" class="form-group">
        <label for="help-desk-ticket-number">Help Desk Ticket Number</label>
        <input
          id="help-desk-ticket-number"
          type="text"
          class="form-control"
          inputmode="numeric"
          maxlength="250"
          v-model="helpDeskTicketNumber"
          @input="onHelpDeskTicketInput"
        />
      </div>
    </div>
    <div v-else-if="status === 'report-lost-or-stolen'">
      <p>This card will initially be locked while the process for reporting the card lost or stolen is facilitated.</p>
    </div>
    <div v-else>
      <p class="small">{{ changeModalText(status) }}</p>
      <div class="table-responsive">
        <table class="table">
          <tr class="row-with-border">
            <th class="small">Card Number</th>
            <th class="small">Card Holder</th>
            <th class="small">{{ divisionName }}</th>
            <th class="small">Status</th>
            <th class="small">Balance</th>
          </tr>
          <tr v-for="card in cards" :key="card.Id">
            <td class="small">**** **** **** {{ card.CardNumber }}</td>
            <td class="small">{{ card.Holder.Name ? card.Holder.Name : card.Holder }}</td>
            <td class="small">{{ card.Division ? card.Division : division.DivisionName }}</td>
            <td class="small">{{ card.CardStatus }}</td>
            <td class="small">
              <v-money currency="USD" locale="en">{{ card.Balance }}</v-money>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'

export default {
  data() {
    return {
      modalText: '',
      isActive: false,
      cardStatusMessage: '',
      helpDeskTicketNumber: ''
    }
  },
  props: {
    status: String,
    cards: Array,
    division: Object,
    isEvedAdmin: { type: Boolean, default: false }
  },
  methods: {
    changeModalText(status) {
      switch (status) {
        case 'close':
          return this.cards.length === 1
            ? 'You are about to close the following EvedPay card:'
            : 'You are about to close the following EvedPay cards:'
        default:
          return 'Are you sure you want to change this card status?'
      }
    },
    resetHelpDeskTicketNumber() {
      this.helpDeskTicketNumber = ''
      this.$emit('helpDeskTicketNumber', '')
    },
    onHelpDeskTicketInput(event) {
      const cleaned = (event.target.value || '').replace(/[^0-9]/g, '')
      if (cleaned !== this.helpDeskTicketNumber) {
        this.helpDeskTicketNumber = cleaned
        event.target.value = cleaned
      }
      this.$emit('helpDeskTicketNumber', this.helpDeskTicketNumber)
    },
    async changeStatus(status, showModal) {
      let statusToChange = status
      const isLockUnlock = status === 'lock' || status === 'unlock'

      if (isLockUnlock && this.isEvedAdmin && !this.helpDeskTicketNumber.trim()) {
        this.cardStatusMessage = 'Help Desk Ticket Number is required.'
        return
      }

      const body = isLockUnlock
        ? { HelpDeskTicketNumber: this.helpDeskTicketNumber.trim() || null }
        : undefined

      for (const card of this.cards) {
        if (isLockUnlock) {
          statusToChange = this.isActive ? 'lock' : 'unlock'

          if ((this.isActive && card.CardStatus === 'Locked') ||
            (!this.isActive && card.CardStatus === 'Active')) {
            this.cardStatusMessage = `Card is already ${this.isActive ? 'locked' : 'active'}.`
            return
          } else {
            this.cardStatusMessage = ''
          }
        }
        try {
          if (card.Id) {
            const response = await this.api.patch(`evedpaycards/${card.Id}/${statusToChange}`, body)
            if (response.status === 200) {
              showModal.showModal = false
              this.resetHelpDeskTicketNumber()
              this.$emit('success')
            } else {
              this.cardStatusMessage = 'Failed to change the status.'
            }
          }
        } catch (error) {
          this.cardStatusMessage = 'Failed to change the status.'
        }
        EventBus.$emit('status-changed', card.Id)
      }
    },

    singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value
    }
  },
  created() {
    this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName)
    this.divisionsName = this.$root.getUser.settings.Labels.DivisionsName
  }
}
</script>

<style lang="scss" scoped>
.card-status-overlay {
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.row-with-border th,
.row-with-border td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.card-status-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardStatus.vue